export const faqs = [
  {
    question: "Does Nevada have a regional passport agency?",
    answer:
      "No. Nevada does not have a regional passport agency. The nearest agencies are the Los Angeles Passport Agency (approximately 270 miles from Las Vegas via I-15) and the San Francisco Passport Agency (approximately 220 miles from Reno via I-80 over Donner Pass). Both require appointments for life-or-death emergencies only. Most Nevada travelers find that using Fast Passport Center's courier service is far more practical.",
  },
  {
    question: "How fast can I get a passport in Nevada?",
    answer:
      "With Fast Passport Center's courier service, Nevada travelers can receive a passport in as little as 24 hours. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks. Since Nevada has no local regional agency, courier service is the fastest option for most Nevada travelers.",
  },
  {
    question: "What is the fastest way to get an emergency passport in Las Vegas?",
    answer:
      "The fastest reliable option for Las Vegas emergency passports is Fast Passport Center's 24–48 hour courier service. Our registered couriers hand-deliver documents directly to State Department processing facilities. The only alternative — driving 270 miles to the Los Angeles Passport Agency — requires an emergency appointment for life-or-death situations only and can take all day or longer.",
  },
  {
    question: "What is the fastest way to get an emergency passport in Reno?",
    answer:
      "For Reno emergency passports, Fast Passport Center's 24–48 hour courier service is the fastest reliable option. The San Francisco Passport Agency (220 miles via I-80) is the nearest agency — but in winter, Donner Pass can make that drive take 5+ hours or more. Our courier service means you never have to risk a mountain crossing for your passport.",
  },
  {
    question: "Where can I get passport photos in Nevada?",
    answer:
      "CVS, Walgreens, UPS Store, FedEx Office, and Walmart locations are available across Clark County (Las Vegas area) and Washoe County (Reno-Sparks area). Important for Las Vegas travelers: casino photo booths do not meet State Department standards. Always use a pharmacy, shipping store, or dedicated photo service for passport photos.",
  },
  {
    question: "Do I need to visit an acceptance facility in Nevada?",
    answer:
      "First-time applicants, minors, and those replacing lost or stolen passports must visit an acceptance facility (typically a post office or county clerk office). Adult renewals can usually be done by mail without an in-person visit. Nevada has acceptance facilities across Las Vegas, Henderson, Reno, Sparks, Carson City, and many smaller communities.",
  },
  {
    question: "Can I renew my passport by mail in Nevada?",
    answer:
      "Yes. If your most recent passport was issued when you were 16 or older, is undamaged, was issued within the last 15 years, and was issued in your current name (or you have legal documentation), you can renew by mail using Form DS-82. Nevada residents can use overnight shipping from Las Vegas, Henderson, Reno, or Sparks for the fastest turnaround.",
  },
];

export default function NevadaFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Nevada Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across Nevada — from Las Vegas to Reno and beyond.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-white rounded-lg border border-gray-200 overflow-hidden"
            >
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}